import { AdditionalServicesHeader } from './Header';
import { AdditionalServicesForm } from './Form';
import { AdditionalServicesLegal } from './Legal';

export const AdditionalServices = () => {
  return (
    <>
      <AdditionalServicesHeader></AdditionalServicesHeader>
      <AdditionalServicesForm></AdditionalServicesForm>
      <AdditionalServicesLegal></AdditionalServicesLegal>
    </>
  );
};
